import { RouteWaypoint } from "@iventis/domain-model/model/routeWaypoint";
import { OptionalExceptFor } from "@iventis/types/useful.types";

export interface IRouteWaypointService {
    getRouteWaypoints: (mapObjectId: string, mapId: string) => Promise<RouteWaypoint[]>;
    putRouteWaypoints: (mapObjectId: string, mapId: string, waypoints: OptionalExceptFor<RouteWaypoint, "coordinates" | "name">[]) => Promise<RouteWaypoint[]>;
}
